var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimes = function SvgTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.059 7.465 4.828-4.781.984-.985c.14-.14.14-.375 0-.562L13.84.105c-.188-.14-.422-.14-.563 0L7.512 5.918 1.699.105c-.14-.14-.375-.14-.562 0L.105 1.137c-.14.187-.14.422 0 .562l5.813 5.766-5.813 5.812c-.14.141-.14.375 0 .563l1.032 1.031c.187.14.422.14.562 0L7.512 9.06l4.781 4.828.984.984c.141.14.375.14.563 0l1.031-1.031c.14-.188.14-.422 0-.563z"
  })));
};
export default SvgTimes;